<template>
	<BaseLayout :footer-full="true" :include-padding="false" :transparent-header="true">
		<OcfHero />
		<OcfFundFeatures />
		<OcfWhyPrivateCredit />
		<AboutOurStrategySection />
		<OurTrackRecordSection />
		<OurBankAndRealEstatePartnersSection class="pt-600-md pt-300-smo" />
		<OcfProperties />
		<CtaSection :benefits-list="[]" theme="dark">
			<template #cta>
				<LeadCaptureOcf component-id="header-component" class="mt-300-md" />
			</template>
		</CtaSection>
	</BaseLayout>
</template>

<script setup lang="ts">
import AboutOurStrategySection from '@components/marketing-site/private-credit/about-our-strategy-section.vue';
import CtaSection from '@components/marketing-site/cta-section.vue';
import LeadCaptureOcf from '@components/lead-capture/lead-capture-ocf.vue';
import OcfFundFeatures from '@components/marketing-site/opportunistic-credit-fund/ocf-fund-features.vue';
import OcfHero from '@components/marketing-site/opportunistic-credit-fund/ocf-hero.vue';
import OcfProperties from '@components/marketing-site/opportunistic-credit-fund/ocf-properties.vue';
import OcfWhyPrivateCredit from '@components/marketing-site/opportunistic-credit-fund/ocf-why-private-credit.vue';
import OurBankAndRealEstatePartnersSection from '@components/marketing-site/private-credit/our-banking-and-real-estate-partners-section.vue';
import OurTrackRecordSection from '@components/marketing-site/private-credit/our-track-record-section.vue';
import { useHead } from '@unhead/vue';

const metaTitle = 'Opportunistic Credit Fund';
const metaDescription =
	"Income-focused investors can take advantage of the dislocation in real estate debt with this private credit fund calibrated for today's market.";

function setup(): void {
	useHead({
		title: metaTitle,
		meta: [
			{ property: 'og:title', content: metaTitle },
			{ name: 'description', content: metaDescription },
			{ property: 'og:description', content: metaDescription }
		]
	});
}

setup();
</script>
